module.exports = __webpack_public_path__ + "static/media/GalleryMain13.5ebb6773.jpg";